export const mainStageAccountId = '710857117001'
export const generalAccountId = '1241706627001'
